import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'semantic-ui-react/dist/commonjs/elements/Button/Button';
import { translate } from 'react-i18next';

import { openDownloadModal } from '../../data/fileImport/modalActions';

class FileDownload extends Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    const resource = {
      session: this.props.session,
      equipment: this.props.equipmentFile
    };
    this.props.dispatch(openDownloadModal(resource));
  }

  render() {
    return <Button onClick={this.openModal}
                   disabled={this.props.session.participations[0] === undefined}>
      {this.props.t('data.download')}
    </Button>
  }
}

export default connect()(translate()(FileDownload));


// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/FileDownload.js